import { render } from "./QuestionsChallenge.vue?vue&type=template&id=188dba8c&scoped=true&translate=no"
import script from "./QuestionsChallenge.vue?vue&type=script&lang=js"
export * from "./QuestionsChallenge.vue?vue&type=script&lang=js"

import "./QuestionsChallenge.vue?vue&type=style&index=0&id=188dba8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188dba8c"]])

export default __exports__